<template>
  <div class="main-container min-h-screen md:min-h-full lg:min-h-screen">
    <nav
      class="padding-nav fixed top-0 z-30 flex w-full items-center justify-between bg-dark-gray px-5"
    >
      <div class="w-16" />
      <img
        class="logo"
        src="@/assets/highway_logo.svg"
        alt="highway logo"
      />
      <div class="invisible w-16 text-right md:visible" />
    </nav>
    <div
      class="width-container height-container tablet-desktop-container mx-auto flex h-screen items-center justify-center overflow-scroll pt-12 md:h-8 md:overflow-hidden"
    >
      <img
        class="-top-2px loading h-12 w-full"
        src="@/assets/loading-v2-yellow.svg"
        alt=""
      />
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
.logo {
  width: 122px;
  height: auto;
}
.padding-nav {
  padding: 14.5px 0;
}

.tablet-desktop-container {
  @apply md:max-w-3xl md:rounded-md md:border md:border-light-gray md:px-4 md:py-8 md:shadow-primary;
}

@media only screen and (min-width: 768px) {
  .main-container {
    padding-top: 5rem;
    padding-bottom: 16px !important;
  }
  .width-container {
    width: 769px;
  }

  .tablet-desktop-container {
    /*  Removing padding-top and padding-bottom values from total container (5rem and 16px) Using main-container as reference */
    min-height: calc(100vh - 5rem - 16px);
    position: relative;
  }

  .tablet-desktop-container > .content-container {
    margin-bottom: 79px;
  }
}
</style>
